import React from 'react';
import BarContainer from './BarContainer';
import { buttons } from './data';
import styles from './SelectionContainer.module.scss';

interface IProps {
    handleClick: (event: any) => void
    groupID: string
    onArrowUp: () => void
    onArrowDown: () => void
}

export default function SelectionContainer(props: IProps) {

    return (
        <>
            <div className={styles["bar-container"]}>
                <BarContainer groupID={props.groupID} onArrowUp={props.onArrowUp} onArrowDown={props.onArrowDown} />
            </div>
            <div className={styles["button-container"]}>
                {buttons.map((item, key) => {
                    return (
                        <div className={styles["buttons"]}>
                            <img src={props.groupID === item.id ? item.buttonActive : item.button}
                                alt="Buttons"
                                id={item.id}
                                onClick={props.handleClick}
                                className={props.groupID === item.id ? styles["selected"] : styles["button"]}
                            />
                        </div>
                    )
                })}
            </div>
        </>
    )
}